import React from "react";
import Container from "../Container";
import AppName from "./AppName";
import Logo from "../Logo";
import Links from "./Links";
import FooterContent from "./Content";
import Link from "./Link";
import { FEEDBACK_LINK, PRIVACY_POLICY, TERMS_OF_USE } from "./constants";

import styles from "./Footer.module.scss";

const Footer = ({ appName, children = null }) => (
  <footer className={styles.base}>
    <Container>
      <div className={styles.logo}>
        <Logo />
        {appName && <AppName>{appName}</AppName>}
      </div>
      {/*   <div className={styles.main}>{children}</div> */}
      <br />
      <div className={styles.copyright}>
        <div>&copy; {new Date().getFullYear()} Optum, Inc.</div>
        <ul>
          <li>
            <a href={PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
              Privacy
            </a>
          </li>
          <li>
            <a href={TERMS_OF_USE} target="_blank" rel="noopener noreferrer">
              Terms of Use
            </a>
          </li>
          <li>
            <a href={FEEDBACK_LINK} target="_blank" rel="noopener noreferrer">
              [+] Feedback
            </a>
          </li>
          <li>
            <a
              href={process.env.REACT_APP_SWAGGER}
              target="_blank"
              rel="noopener noreferrer"
            >
              API
            </a>
          </li>
        </ul>
      </div>
    </Container>
  </footer>
);

Footer.Links = Links;
Footer.Content = FooterContent;
Footer.Link = Link;

export default Footer;
